import React, { useEffect, useState } from 'react';
import { prefersReducedMotion } from '../guide/motion';

// A "the model is thinking" indicator: a twinkling glyph beside a gerund that
// keeps changing, drawn from product-management vocabulary.
export const PM_THINKING_WORDS = [
  // Prioritization
  'Prioritizing', 'Deprioritizing', 'RICE-scoring', 'ICE-scoring', 'MoSCoW-ing', 'Kano-modeling',
  'Stack-ranking', 'Weighing trade-offs', 'Saying no', 'Cost-of-delaying', 'Weighting WSJF',
  'Picking the bets', 'Sorting must-haves', 'Effort-vs-impacting',
  // Discovery & research
  'Discovering', 'Hypothesizing', 'Synthesizing', 'Validating', 'Interviewing users', 'Jobs-to-be-doning',
  'Affinity-mapping', 'Persona-building', 'Journey-mapping', 'Problem-framing', 'Assumption-testing',
  'Opportunity-treeing', 'Clustering feedback', 'Reading the tickets', 'Listening to customers',
  'Finding the pain', 'Smoke-testing', 'Fake-dooring', 'Wizard-of-Ozzing', 'Five-whys-ing',
  // Strategy & alignment
  'Roadmapping', 'North-starring', 'Mapping OKRs', 'Aligning stakeholders', 'Pre-wiring the exec',
  'Narrative-crafting', 'Vision-casting', 'Positioning', 'Moat-digging', 'Competitive-scanning',
  'Finding product-market fit', 'Defining the ICP', 'Strategizing', 'Socializing the plan',
  'Getting buy-in', 'Managing up', 'Disagreeing and committing',
  // Delivery
  'Triaging', 'Backlog-grooming', 'Refining stories', 'Slicing epics', 'T-shirt sizing', 'Story-pointing',
  'Story-mapping', 'Sprint-planning', 'Scoping', 'Trimming scope', 'Cutting the fat', 'Spiking',
  'Unblocking', 'De-risking', 'Writing the PRD', 'Drafting acceptance criteria', 'Defining done',
  'Chasing dependencies', 'Burning down', 'Stand-upping', 'Retro-ing', 'Iterating', 'MVP-ing', 'Shipping',
  'Feature-flagging', 'Dogfooding', 'Release-noting',
  // Metrics & growth
  'Funnel-diving', 'Cohort-slicing', 'A/B-testing', 'Moving the needle', 'Measuring activation',
  'Chasing retention', 'Reducing churn', 'Sizing the TAM', 'Opportunity-sizing', 'Instrumenting events',
  'Reading the dashboards', 'Finding the aha moment', 'Pricing-and-packaging', 'Growth-looping',
  'Leading-indicatoring', 'Counter-metricking',
  // Playful
  'Bikeshedding', 'Parking-lotting', 'Circling back', 'Taking it offline', 'Boiling the ocean (gently)',
  'Peeling the onion', 'Herding the cats', 'Thinking big, starting small', 'Building the right thing',
  'Falling in love with the problem', 'Shipping to learn', 'Consulting the backlog oracle',
];
const GLYPHS = ['·', '✢', '✳', '✶', '✻', '✽', '✻', '✶', '✳', '✢'];

const pick = (words, current) => {
  if (words.length < 2) return words[0];
  let next = current;
  while (next === current) next = words[Math.floor(Math.random() * words.length)];
  return next;
};

export default function ThinkingRoulette({ words = PM_THINKING_WORDS, interval = 2200, label, children, className = '' }) {
  const [word, setWord] = useState(() => pick(words));
  const [glyph, setGlyph] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setWord(current => pick(words, current)), interval);
    return () => clearInterval(id);
  }, [words, interval]);
  useEffect(() => {
    if (prefersReducedMotion()) return undefined;
    const id = setInterval(() => setGlyph(i => (i + 1) % GLYPHS.length), 120);
    return () => clearInterval(id);
  }, []);

  return <div className={`thinking-roulette ${className}`}>
    <div className="thinking-roulette__spin" aria-hidden="true">
      <span className="thinking-roulette__glyph">{GLYPHS[glyph]}</span>
      <span key={word} className="thinking-roulette__word">{word}…</span>
    </div>
    {label && <strong className="thinking-roulette__label">{label}</strong>}
    {children}
  </div>;
}
